import React from 'react';

interface OcrTranscriptionIconProps {
  style?: React.CSSProperties;
}

const OcrTranscriptionIcon: React.FC<OcrTranscriptionIconProps> = ({ style }) => (
  <svg style={style} viewBox="0 0 26 30">
    <title>Transcription</title>
    <path d="M12.99 0L0 7.5v15L12.99 30l12.99-7.5v-15L12.99 0z" fill="#6A11EA" />
    <path d="M25.98 7.5H0v3h25.98v-3z" fill="#FD9D52" />
    <path d="M25.98 13.5H0v3h25.98v-3z" fill="#DD45D3" />
    <path d="M25.98 19.5H0v3h25.98v-3z" fill="#943CFF" />
  </svg>
);

export default OcrTranscriptionIcon;
